export { default as Favourite } from './Favourite.js';

export const axios = require('axios');

export const config = {
    api: 'https://my-json-server.typicode.com/mihika-shilpi/e28-p4-albums/albums/',
}

export let store = {
    favouritesCount: 0
}
